/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { EditorCellModel } from "./EditorCellModel";
import { markType } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var EditorCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorCellPresenter, _super);
    function EditorCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(EditorCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    EditorCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (b.as) {
            if (b.ax(EditorCellModel.ld) || b.ax(EditorCellModel.lb) || b.ax(EditorCellModel.lc) || b.ax(EditorCellModel.le)) {
                this.d.cd = b.k3;
                this.d.c6 = b.lm;
                this.d.da = b.ls;
                this.d.b9 = b.kx;
            }
            if (b.ax(EditorCellModel.la)) {
                this.d.cb = b.kz;
            }
            if (b.ax(EditorCellModel.fm)) {
                this.d.c7 = b.gp;
            }
            if (b.ax(EditorCellModel.lf)) {
                this.d.dw(b.k1 == null);
            }
            if (b.ax(CellModel.ey)) {
                this.d.cq = b.af;
            }
            if (b.ax(EditorCellModel.lg)) {
                if (stringIsNullOrWhiteSpace(b.lx)) {
                    this.d.cw = false;
                    this.d.dk();
                }
                else {
                    this.d.cw = true;
                    this.d.d0(b.lx, b.cc, b.cd, b.gg, b.e0);
                }
            }
            if (b.ax(EditorCellModel.li)) {
                this.d.c0 = b.k7;
            }
        }
        if (b.ax(EditorCellModel.lh)) {
            this.d.a6();
        }
    };
    EditorCellPresenter.$t = markType(EditorCellPresenter, 'EditorCellPresenter', CellPresenterBase.$);
    return EditorCellPresenter;
}(CellPresenterBase));
export { EditorCellPresenter };
//# sourceMappingURL=EditorCellPresenter.js.map
